import React, { useState } from "react";
import {
  Table,
  TableContainer,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  Paper,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import { ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon, DoneAll, HighlightOff } from "@material-ui/icons";

// components
import { Button } from "../../../../components/Wrappers";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    margin: "auto",
  },
  table: {
    minWidth: 650,
  },
  tableContainer: {
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  },
  headerCell: {
    fontWeight: "bold",
    backgroundColor: "#B5B5B5", // Change header background color
    color: "black", // Change header text color
  },
  row: {
    height: 48, // Adjust the value based on your preference
  },
  iconCell: {
    display: "flex",
    alignItems: "center",
  },
  detailsCell: {
    borderBottom: "none",
  },
  expandIcon: {
    marginRight: theme.spacing(1),
  },
}));

export default function TableComponent({ data }) {
  const [expandedRows, setExpandedRows] = useState([]);
  const classes = useStyles();

  const handleToggleRow = (rowId) => {
    setExpandedRows((prevRows) =>
      prevRows.includes(rowId)
        ? prevRows.filter((row) => row !== rowId)
        : [...prevRows, rowId]
    );
  };

  const isRowExpanded = (rowId) => expandedRows.includes(rowId);

  return (
    <div className={classes.root}>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.headerCell}>Engine Number</TableCell>
              <TableCell className={classes.headerCell}>Defect Name</TableCell>
              <TableCell className={classes.headerCell}>Status</TableCell>
              <TableCell className={classes.headerCell}>Details</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map(
              ({
                EngineNumber,
                Model,
                DefectName,
                SubCategory,
                Observation,
                Category,
                Zone,
                Station,
                OperatorCode,
                DefectGenerationTime,
                Remarks,
                DetectedAt,
                Status,
                Id,
              }) => (
                <React.Fragment key={Id}>
                  <TableRow className={classes.row}>
                    <TableCell>{EngineNumber}</TableCell>
                    <TableCell>{DefectName}</TableCell>
                    <TableCell className={classes.iconCell}>
                      {Status === "RECTIFIED" ? (
                        <DoneAll style={{ color: "green" }} />
                      ) : (
                        <HighlightOff style={{ color: "red" }} />
                      )}
                      {Status}
                    </TableCell>
                    <TableCell>
                      <IconButton
                        aria-label="expand"
                        size="small"
                        onClick={() => handleToggleRow(Id)}
                      >
                        {isRowExpanded(Id) ? (
                          <ExpandLessIcon className={classes.expandIcon} />
                        ) : (
                          <ExpandMoreIcon className={classes.expandIcon} />
                        )}
                      </IconButton>
                    </TableCell>
                  </TableRow>
                  {isRowExpanded(Id) && (
                    <TableRow>
                      <TableCell colSpan={4} className={classes.detailsCell}>
                        <div>
                          <strong>Model:</strong> {Model}
                          <br />
                          <strong>Sub Category:</strong> {SubCategory}
                          <br />
                          <strong>Observation:</strong> {Observation}
                          <br />
                          <strong>Category:</strong> {Category}
                          <br />
                          <strong>Zone:</strong> {Zone}
                          <br />
                          <strong>Station:</strong> {Station}
                          <br />
                          <strong>Operator:</strong> {OperatorCode}
                          <br />
                          <strong>Defect Generation Time:</strong> {DefectGenerationTime}
                          <br />
                          <strong>Remarks:</strong> {Remarks}
                          <br />
                          <strong>Detected At:</strong> {DetectedAt}
                        </div>
                      </TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
